import { AJAX_TYPE } from "../config";

// 轨迹
export default {
    // 轨迹查询
    [`getTrackQueryApi`]: {
        url: '/api/user/trackQueryTrack',
        type: AJAX_TYPE.POST
    },
    // 获取运单信息
    [`getLogisticsAddressInfoByCodeApi`]: {
        url: `/api/vehicle/v1/logisticsOrderSub/getLogisticsAddressInfoByCode:code`,
        type: AJAX_TYPE.POST
    },
    // 根据轨迹查询id获取轨迹点列表
    [`pointListByQueryId`]: {
        url: `/api/user/pointListByQueryId?queryId=:queryId`,
        type: AJAX_TYPE.Get
    },
    // 轨迹点信息查询
    [`queryPointInfoApi`]: {
        url: '/api/user/getPointInfo',
        type: AJAX_TYPE.POST
    },
    // 获取查询轨迹记录
    [`getTrackRecordsApi`]: {
        url: `/api/user/listTrackQueryTrack`,
        type: AJAX_TYPE.POST
    },
    // 获取查询定位记录
    [`getPositionRecordsApi`]: {
        url: `/api/user/listTrackQueryLocation`,
        type: AJAX_TYPE.POST
    },
    // 获取查询定位数据
    [`getPositionDataApi`]: {
        url: `/api/user/trackQueryLocation`,
        type: AJAX_TYPE.Get
    },
    // 查询次数
    [`getQueryCountApi`]: {
        url: `/api/isx/v1/track/service/getUserTrackBalanceState`,
        type: AJAX_TYPE.Get
    },
    // 获取用户轨迹使用情况统计
    [`trackQueryStatistics`]: {
        url: `/api/user/trackQueryStatistics`,
        type: AJAX_TYPE.Get
    },
    // 获取用户充值记录
    [`payRecords`]: {
        url: `/api/user/payRecords`,
        type: AJAX_TYPE.POST
    },
     // 获取费用统计列表
     [`usedStatisticsRecords`]: {
        url: `/api/user/usedStatisticsRecords`,
        type: AJAX_TYPE.POST
    },
    // 获取费用统计列表
    [`usedRecords`]: {
        url: `/api/user/usedRecords`,
        type: AJAX_TYPE.POST
    },
    // 充值
    [`userRecharge`]: {
        url: `/api/user/userRecharge`,
        type: AJAX_TYPE.POST
    },
};
